<p-table [value]="groups" [scrollable]="true" scrollHeight="50vh" selectionMode="single" #table
    [(selection)]="selectedGroup" dataKey="id" [globalFilterFields]="['name']">

    <ng-template pTemplate="header">
        <tr class="hidden">
            <th class="w-3rem"></th>
            <th></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="caption">
        <div class="flex justify-items-center">

            <div class="flex-1"  id="searchBarContainer">
                <span class="p-input-icon-left w-full">
                    <i class="ml-1 far fa-magnifying-glass"></i>
                    <input type="text" class="w-full" pInputText id="searchBar"
                           (keyup)="table.filterGlobal($event.target['value'], 'contains')" />
                </span>
            </div>

            <div> <p-button label="Accept" i18n-label="@@profile-picker-groups.dialog.buttons.accept"
                (onClick)="onAcceptGroup()" [disabled]="selectedGroup==null" class="ml-2" severity="secondary"></p-button></div>
        </div>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td i18n="@@profile-picker-groups.fields-table.empty">No groups found
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-group let-index="rowIndex">
        <tr class="mb-2">
            <td>
                <p-tableRadioButton [id]="group.id" [inputId]="group.id" [value]="group"></p-tableRadioButton>
            </td>
            <td>
                <label [for]="group.id" class="mb-1">{{group.name}} ({{group.numberOfMembers}})</label>

            </td>
        </tr>
        <tr>
            <td class="spacer-row" [colSpan]="12"></td>
          </tr>
    </ng-template>
    <div> <p-button label="Accept" i18n-label="@@profile-picker-groups.dialog.buttons.accept"
                (onClick)="onAcceptGroup()" [disabled]="selectedGroup==null" class="ml-2 sr-only" severity="secondary"></p-button></div>
</p-table>
